import React from 'react';

import { Box } from '@mui/material';

import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import dateRangeValidation from '../../../utils/reports/dateRangeValidation';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const ExtendedTransactions = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Date range" description="Only transactions created within this date range are included. Leave empty to include the full available range.">
      <RangeFields
        from={(
          <SmartDateInput fullWidth validate={[isPastDate, dateRangeValidation]} source="report.from" helperText={false} label="From" />
        )}
        to={(
          <SmartDateInput fullWidth validate={[isPastDate, dateRangeValidation]} source="report.to" helperText={false} label="To" />
        )}
      />
    </FieldBox>
  </Box>
);

export default ExtendedTransactions;
